import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { User } from '../types';
import { UserUrl } from './UserUrl';
import { UserSchema, UserValidFormDataType } from '../schema';

const postUser = (user: UserValidFormDataType) =>
  apiClient
    .post<User>(
      expand(UserUrl.USER, { id: undefined }),
      UserSchema.parseMutationDto(user)
    )
    .then((response) => response.data);

const patchUser = (id: number, user: Partial<UserValidFormDataType>) =>
  apiClient
    .patch<User>(
      expand(UserUrl.USER, { id }),
      UserSchema.parseMutationDto(user)
    )
    .then((response) => response.data);

const deleteUser = (id: number) =>
  apiClient
    .delete<void>(expand(UserUrl.USER, { id }))
    .then((response) => response.data);

export const useUserMutation = createApiMutationHook(
  ['user'],
  getMutationFn(postUser, patchUser, deleteUser)
);
